/** Вкладки настроек сайта. */
export type SettingsTab = 'general' | 'addresses' | 'connect';

export function isSettingsTab(value: unknown): value is SettingsTab {
  return value === 'general' || value === 'addresses' || value === 'connect';
}
